/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { Fragment } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { Button } from '@components/common';
import { makeSelectTranslationWizardImportPersonalData } from '@modules/internationalization/intSelectors';
import { IImportPersonalDataExportModal, IWizardImportPersonalDataTranslation } from '@modules/internationalization/types/wizards/importPersonalData';
import { modalOpen } from '@modules/modal/modalActions';
import { IModalOpenPayload } from '@modules/modal/types/modalActionTypes';
import { IModalRenderProps } from '@modules/modal/types/modalTypes';
import { IWizardState } from '@modules/wizard/wizardReducer';
import { makeSelectWizardStepName } from '@modules/wizard/wizardSelectors';
import { IRootReducer } from '@reducers/rootReducer';

import { EWizardImportPersonalDataSteps } from '../wizardImportPersonalDataConstant';
import { IWizardImportPersonalDataReducer } from '../wizardImportPersonalDataReducer';
import { makeSelectWizardImportPersonalDataErrorRowsAmount } from '../wizardImportPersonalDataSelectors';
import WizardImportPersonalDataExportModal from './WizardImportPersonalDataExportModal/WizardImportPersonalDataExportModal';


interface IWizardImportPersonalDataTitleElementsProps {
    title: string;
}

const WizardImportPersonalDataTitleElements = ({
    stepName,
    title,
    translation,
    openModal,
    errorRowsAmount,
}: IWizardImportPersonalDataTitleElementsProps & IConnectedProps & IDispatchProps) => {

    const stepTranslation = translation[EWizardImportPersonalDataSteps.ConfirmImportStep];
    const exportModalTranslation: IImportPersonalDataExportModal = stepTranslation.exportModal;

    const exportErrorsHandler = () => {
        openModal({
            render: (props: IModalRenderProps) =>
                <WizardImportPersonalDataExportModal
                    translation={exportModalTranslation}
                    onCloseModal={props.onCloseModal}
                />,
        });
    }

    return (
        <Fragment>
            {stepName === EWizardImportPersonalDataSteps.ConfirmImportStep && !!errorRowsAmount && (
                <Button
                    className="button__button-content_export"
                    dataName="wizard-import-personal-data-open-export-error"
                    kind="small"
                    onClick={exportErrorsHandler}
                >
                    {title}
                </Button>
            )}
        </Fragment>
    );
};


interface IConnectedProps extends Pick<IWizardState, 'stepName'>, Pick<IWizardImportPersonalDataReducer, 'errorRowsAmount'>{
    translation: IWizardImportPersonalDataTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    stepName: makeSelectWizardStepName(),
    errorRowsAmount: makeSelectWizardImportPersonalDataErrorRowsAmount(),
    translation: makeSelectTranslationWizardImportPersonalData(),
});

interface IDispatchProps {
    openModal: (payload: IModalOpenPayload) => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    openModal: (payload) => dispatch(modalOpen(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WizardImportPersonalDataTitleElements);
